export default {
    cz: {
        continue: 'Pokračovat v nákupu',
        cart: 'Přejít do košíku',
    },
    sk: {
        continue: 'Pokračovať v nákupe',
        cart: 'Prejsť do košíka',
    },
}
